<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Clients
                    </div>
                    <div class="card-block">
                        <div class="row">
                            <div class="col-md-3">
                                <button class="btn btn-primary" @click="createNewClientForm()">Add new client</button>
                            </div>
                            <div class="col-md-6 pr-0" style="display: inline-flex;">
                                <div class="col-md-4 pr-0">
                                    <label class="form-control-label" style="padding-top: 7px;">Search client</label>
                                </div>
                                <div class="col-md-8 ml-0 pl-0 pr-0">
                                    <input v-model="search_value" class="form-control" type="search"/>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-1" v-if="addClient">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Name</label>
                                        <input type="text" class="form-control" v-model="new_client.name" placeholder="Enter name"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Title</label>
                                        <input @click="copy_name = false" type="text" class="form-control" v-model="new_client.title" placeholder="Enter title"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Registration number</label>
                                        <input type="text" class="form-control" v-model="new_client.reg_id" placeholder="Enter registration number"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Vat number</label>
                                        <input type="text" class="form-control" v-model="new_client.vat_nr" placeholder="Enter vat nr"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Legal address</label>
                                        <input type="text" class="form-control" v-model="new_client.legal_address" placeholder="Enter legal address"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Actual address</label>
                                        <input type="text" class="form-control" v-model="new_client.actual_address" placeholder="Enter actual address"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="vcentered-text">Bank name</label>
                                        <input type="text" class="form-control" v-model="new_client.bank_name" placeholder="Enter bank name"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Bank account</label>
                                        <input type="text" class="form-control" v-model="new_client.bank_account" placeholder="Enter bank account"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="vcentered-text">Bank swift number</label>
                                        <input type="text" class="form-control" v-model="new_client.bank_swift" placeholder="Enter bank swift number"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Phone number</label>
                                        <input type="text" class="form-control" v-model="new_client.phone_nr" placeholder="Enter phone number"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Email</label>
                                        <input type="text" class="form-control" v-model="new_client.email" placeholder="Enter email"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Signatory name</label>
                                        <input type="text" class="form-control" v-model="new_client.signatory_name" placeholder="Enter signatory full name"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="vcentered-text">Signatory position</label>
                                        <input type="text" class="form-control" v-model="new_client.signatory_position" placeholder="Enter signatory position"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mt-1">
                                <div class="col-md-3 pull-right text-right">
                                    <button type="button" class="btn btn-primary" @click="saveNewClient()">Save</button>
                                    <button type="button" class="btn btn-secondary" @click="emptyInputs()">Cancel</button>
                                </div>
                            </div>
                        </div>
                        <table class="table table-bordered table-striped table-condensed mt-1">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Registration number</th>
                                <th>Legal address</th>
                                <th>Signatory position</th>
                                <th>Signatory name</th>
                                <th>Options</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="filtered_clients.length" v-for="client in filtered_clients">
                                <td>{{client.id}}</td>
                                <td>{{client.title}}</td>
                                <td>{{client.reg_id}}</td>
                                <td>{{client.legal_address}}</td>
                                <td>{{client.signatory_position}}</td>
                                <td>{{client.signatory_name}}</td>
                                <td>
                                <i class="fa fa-edit fa-lg action" @click="editClient(client)" rel="tooltip" title="Edit client"></i>
                                <i class="fa fa-trash fa-lg action" @click="deleteClient(client)" rel="tooltip" title="Delete client"></i>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <v-page :setting="pageSet" @page-change="pageChange"></v-page>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VueNotifications from 'vue-notifications';
import vPage from '../libraries/vPage/vPage.vue';

export default {
  name: 'clients',
  components: {
    vPage
  },
  data() {
    return {
      addClient: false,
      search_value: '',
      timeout_id: '',
      pageSet: {
        totalRow: '',
        language: 'en',
        pageSizeMenu: [10, 20, 50, 100],
        pageNumber: 1,
        pageSize: 10,
        currentPage: ''
      },
      new_client: {
        name: '',
        title: '',
        reg_id: '',
        vat_nr: '',
        legal_address: '',
        actual_address: '',
        bank_name: '',
        bank_account: '',
        bank_swift: '',
        phone_nr: '',
        email: '',
        signatory_position: '',
        signatory_name: ''
      },
      all_clients: '',
      confirmation_options: {
        okText: 'Delete',
        cancelText: 'Cancel',
        verification: 'delete'
      },
      copy_name: true
    };
  },
  watch: {
    'new_client.name': function (val) {
      if (this.copy_name) {
        this.new_client.title = val;
      }
    },
    deleted_client: function (val) {
      if (this.deleted_client.status == 'success') {
        this.showSuccessMsg({ title: 'Client delete status', message: `Client ${this.deleted_client.data.name} deleted!` });
      }
      if (this.deleted_client.status == 'error') {
        this.showErrorMsg({ title: 'Client delete status', message: this.deleted_client.message });
      }
    },
    filtered_clients: function (val) {
      this.pageSet.totalRow = this.filtered_clients_count;
    },
    search_value: function (val) {
      this.pageSet.currentPage = 0;
      const vm = this;
      if (vm.timeout_id) {
        clearTimeout(vm.timeout_id);
      }
      vm.timeout_id = setTimeout(() => {
        vm.pageSet.currentPage = 1;
        vm.GET_CLIENTS_LIST_FILTERED({ search_value: vm.search_value, pageNumber: 1, pageSize: vm.pageSet.pageSize });
      }, 1000);
    },
  },
  computed: {
    ...mapGetters('Clients', [
      'filtered_clients',
      'client_updated',
      'deleted_client',
      'filtered_clients_count'
    ])
  },
  methods: {
    ...mapActions('Clients', [
      'SAVE_NEW_CLIENT',
      'GET_CLIENTS_LIST_FILTERED',
      'DELETE_CLIENT'
    ]),
    pageChange(pInfo) {
      this.pageSet.pageNumber = pInfo.pageNumber;
      this.pageSet.pageSize = pInfo.pageSize;
      this.GET_CLIENTS_LIST_FILTERED({ search_value: this.search_value, pageNumber: this.pageSet.pageNumber, pageSize: this.pageSet.pageSize });
      //                console.log(pInfo);//{pageNumber: 1, pageSize: 10}
    },
    createNewClientForm() {
      this.addClient = true;
    },
    editClient(client) {
      this.$router.push({ name: 'EditClient', params: { id: client.id } });
    },
    saveNewClient() {
      this.SAVE_NEW_CLIENT(this.new_client).then((response) => {
        this.showSuccessMsg({ title: 'Client save status', message: 'Client created successfully!' });
        this.emptyInputs();
        this.GET_CLIENTS_LIST_FILTERED({ search_value: this.search_value, pageNumber: this.pageSet.pageNumber, pageSize: this.pageSet.pageSize });
      }, (err) => {
        const errors = err.response.data.data;
        for (const i in errors) {
          this.showErrorMsg({ title: 'Client save status', message: errors[i] });
        }
      });
    },
    emptyInputs() {
      this.addClient = false;
      this.new_client = {
        name: '',
        title: '',
        reg_id: '',
        vat_nr: '',
        legal_address: '',
        actual_address: '',
        bank_name: '',
        bank_account: '',
        bank_swift: '',
        phone_nr: '',
        email: '',
        signatory_position: '',
        signatory_name: ''
      };
    },
    deleteClient(client) {
      const vm = this;
      this.$dialog.confirm(`Delete client - ${client.name}?`, this.confirmation_options)
        .then(() => {
          vm.DELETE_CLIENT(client.id);
        })
        .catch(() => {
          //                        console.log('Clicked on cancel');
        });
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.GET_CLIENTS_LIST_FILTERED({ search_value: this.search_value, pageNumber: this.pageSet.pageNumber, pageSize: this.pageSet.pageSize });
  }
};
</script>

<style lang="scss" scope>
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }

    .dg-btn--ok {
        color: #fff;
        background-color: #20a8d8;
        border-color: #20a8d8;
        border-radius: var(--border-radius);
    }

    .dg-btn--ok:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #1985ac;
        border-color: #187fa3;

    }

    .dg-btn--ok:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--ok:disabled,
    .dg-btn--ok.is-disabled {
        opacity: .5;
    }

    .dg-btn--cancel {
        color: #263238;
        background-color: #fff;
        border-color: #b0bec5;
        border-radius: var(--border-radius);
    }

    .dg-btn--cancel:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #e6e5e5;
        border-color: #8da1ab;

    }

    .dg-btn--cancel:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--cancel:disabled,
    .dg-btn--cancel.is-disabled {
        opacity: .5;
    }
</style>
